import { useMemo } from 'react';

import { Track, TrackMap } from '../Tracks.types';

// ts-prune-ignore-next
export const groupBy: (
    trackMap: TrackMap,
    key: (track: Track) => string
) => Map<string, Track[]> = (trackMap, key) => {
    const map = new Map<string, Track[]>();

    trackMap.forEach((track) => {
        const trackKey = key(track);

        if (map.has(trackKey)) {
            map.get(trackKey)!.push(track);
        } else {
            map.set(trackKey, [track]);
        }
    });

    return map;
};

export const useGroupBy: (
    trackMap: TrackMap,
    key: (track: Track) => string
) => Map<string, Track[]> = (trackMap, key) =>
    useMemo(() => groupBy(trackMap, key), [key, trackMap]);

export const useTrackMapTransform: (
    trackMap: TrackMap,
    mappingFunction: (t: Track) => Track
) => TrackMap = (trackMap, mappingFunction) => {
    const newMap: TrackMap = new Map<string, Track>();

    trackMap.forEach((track, key) => newMap.set(key, mappingFunction(track)));

    return newMap;
};
